import { render, staticRenderFns } from "./ListVehiclesPage.vue?vue&type=template&id=3745375e"
import script from "./ListVehiclesPage.vue?vue&type=script&lang=js"
export * from "./ListVehiclesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports